webpackJsonp([14],{

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(211)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(238),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sponsors',
  data: function data() {
    return {
      sponsors: [
      // {
      //   name: 'Decent Dcore | Advanced Blockchain Ecosystem',
      //   src: '/static/img/partners/DECENT_logo_vertical_color.png',
      //   url: 'https://decent.ch/dcore/',
      //   desc: 'Founded in 2015, DECENT is one of the first blockchain companies. DECENT has developed their own blockchain protocol; DCore, a platform that empowers users to create or migrate applications into a blockchain environment. Cooperating closely with top investment funds and incubators, DECENT is dedicated to building an ecosystem upon its proprietary blockchain technology to help developers and businesses adapt to a decentralized future, especially within the media and entertainment industries.'
      // },
      {
        name: 'HOSU | office solutions',
        src: '/static/img/sponsors/hosu.png',
        url: 'http://www.hosu.sk/en/home.html',
        desc: 'We deal with analysis, design and furnishing of administrative spaces. Our aim is to effectively use the space of an organization and create a friendly workspace in which people work more efficiently and enthusiastically. Our approach focuses primarily on proper acoustics, ergonomics and sustainability. The result of our work is a functional design and comfortable workplace.'
      }, {
        name: 'BitPanther',
        src: '/static/img/sponsors/bitpanther.svg',
        url: 'https://www.bitpanther.com/en',
        desc: 'is a European financial technology platform focused on helping people to get access to digital currencies. BitPanther is a registered Slovakian company, compliant with Slovak and EU regulations.'
      }],
      mediaPartners: [{
        name: 'Starfish.mission',
        src: '/static/img/partners/Starfish_Logo_Horizontal Mission@4x.png',
        url: 'https://starfish.network/',
        desc: 'is a co-working space and community hub for blockchain, Web 3.0, and AI pioneers to connect, collaborate and build.'
      }, {
        name: 'Startitup',
        src: '/static/img/partners/siu_new_logo_white.svg',
        url: 'https://www.startitup.sk/',
        desc: 'je startupový komunitný portál. Je štartovacou čiarou pre množstvo mladých ľudí. Takých, ktorí chcú zatriasť týmto svetom a ukázať že aj na Slovensku a v Čechách sú šikovní ľudia. Startitup je taktiež výnimočný tým, že je tu všetko zadarmo.'
      }, {
        name: 'Robime.it',
        src: '/static/img/sponsors/robime_it.jpg',
        url: 'https://robime.it',
        desc: 'je portál pre IT ľudí, ale aj pre tých, ktorí s IT úzko spolupracujú – konzultanti, finančníci, obchodníci, personalisti, marketéri, apod. Nájdete u nás pracovné ponuky, tipy a rady ako sa ďalej posunúť v kariére a pohľad do sveta informačných technológii.'
      }, {
        name: 'OneCoworking',
        src: '/static/img/partners/oneCoworking.png',
        url: 'https://onecoworking.com/',
        desc: 'Get access to the best coworking spaces around the world with one app and one membership!'
      }]
    };
  }
});

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(99)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Sponsors.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(187);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(100)("318fe54c", content, true, {});

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sponsors"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-10"
  }, [_c('article', {
    staticClass: "tile is-child notification is-black is-size-5"
  }, [_vm._m(1), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.sponsors.slice(0, 3)), function(r) {
    return _c('div', {
      staticClass: "column is-4"
    }, [_c('a', {
      attrs: {
        "href": r.url
      }
    }, [_c('img', {
      attrs: {
        "src": r.src,
        "alt": r.name
      }
    }), _c('br'), _vm._v(_vm._s(r.name))]), _vm._v("\n              " + _vm._s(r.desc) + "\n            ")])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("Media & Network Partners")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.mediaPartners.slice(0, 4)), function(r) {
    return _c('div', {
      staticClass: "column"
    }, [_c('a', {
      attrs: {
        "href": r.url
      }
    }, [_c('img', {
      attrs: {
        "src": r.src,
        "alt": r.name
      }
    }), _c('br'), _vm._v(_vm._s(r.name))]), _vm._v("\n              " + _vm._s(r.desc) + "\n            ")])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "has-text-grey-light is-size-4"
  }, [_vm._v("\n            Want to sponsor us? Your name will be known in our hackerspace & cowork. We hosted 1000+ technical and technological events so far.\n            We can give you huge marketing push or find you geeks, engineers, software developers you are searching for.\n            We are their daily place, where their come hangout on evenings or work during day.\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-10"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/eventspace/IMG_20190327_190708_vedatour.jpg",
      "alt": "progressbar coworking bratislava meetup"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v("Beloved & Brave Sponsors of "), _c('a', {
    attrs: {
      "href": "https://cowork.progressbar.sk"
    }
  }, [_vm._v(" Progressbar Cowork")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.2531bdce7b4762c31f51.js